module.exports = __webpack_public_path__ + "static/icons/icon-my-snow-e27c55c39a38dde1349dc993eff426a0.svg";